import { render } from "./RuiListFlat.vue?vue&type=template&id=61af60cb&scoped=true"
import script from "./RuiListFlat.vue?vue&type=script&lang=ts"
export * from "./RuiListFlat.vue?vue&type=script&lang=ts"

import "./RuiListFlat.vue?vue&type=style&index=0&id=61af60cb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61af60cb"

export default script